module.exports = __webpack_public_path__ + "img/checked-blue.1fa9ef26.svg";